<template>
  <div class="content" :style="{'padding-bottom': productList.length + 'rem'}">
    <img class="img" :src="publicImg + '/1_1.png'" alt="">
    <div class="name">
      <div class="item">超级教练路考仪</div>
      <div class="item2">
        <span>赚钱利器</span>
        <span>智能学车辅助系统</span>
      </div>
    </div>
    <img class="img" :src="publicImg + '/2.png'" alt="">
    <div class="support">
      <div class="title">支持车型 ({{count}}种)</div>
      <div class="wrap">
        <div>
          <div class="item" v-for="(item, index) in support" :key="index">
            <img :src="item.src" alt="">
            <div class="item-name">{{item.name}}</div>
          </div>
        </div>
      </div>
    </div>
    <img class="img" :src="publicImg + '/3-1.png'" alt="">
    <!-- <img class="img" :src="public_path + '/static/images/detail.png'" alt=""> -->
    <div v-if="channel_no !== 'agent'" class="my-orders" @click="getMyOrders">
      <img :src="public_path + '/static/images/my_orders.png'" alt="">
    </div>
    <div class="btn">
      <button v-for="product in productList" :key="product.id" v-if="product.is_display == 1" @click="toBuy(product.id)">{{product.type == 0 ? '我要领取' : '我要购买'}}</button>
      <!-- <button style="margin-top:.06rem" @click="toBuy(1)">我要购买</button> -->
    </div>
  </div>
</template>
<script>
import cjjl from '../../../static/js/chaojijiaolian-jl.js'
import URL from '../../../static/js/url.js'
import { getEcmallProducts, getCarModel } from '@/http/api'
const imgUrl = 'http://picture.eclicks.cn/kaojiazhao/public/rem'

export default {
  data () {
    return {
      count: 12,
      publicImg: 'http://picture.eclicks.cn/kaojiazhao/public/rem',
      isApp: cjjl.isApp,
      public_path: process.env.PUBLICK_PATH,
      channel_no: URL.getQueryString('channel_no') || '',
      agent_id: URL.getQueryString('agent_id') || '0',
      productList: [],
       support: [
        {
          src: `${imgUrl}/stn.jpg`,
          name: '大众新桑塔纳'
        },
        {
          src: `${imgUrl}/skd.jpg`,
          name: '斯柯达'
        },
        {
          src: `${imgUrl}/jd.jpg`,
          name: '大众新捷达'
        },
        {
          src: `${imgUrl}/byd.jpg`,
          name: '比亚迪速锐'
        },
        {
          src: `${imgUrl}/xbl.jpg`,
          name: '大众新宝来'
        },
        {
          src: `${imgUrl}/dfbz301.jpg`,
          name: '东风标志301'
        },
        {
          src: `${imgUrl}/xtl.jpg`,
          name: '东风雪铁龙新爱丽舍'
        },
        {
          src: `${imgUrl}/dnV5.jpg`,
          name: '东南V5'
        },
        {
          src: `${imgUrl}/cq.jpg`,
          name: '广汽传祺GA3S'
        },
        {
          src: `${imgUrl}/cqGA5.jpg`,
          name: '广汽传祺GA5'
        },
        {
          src: `${imgUrl}/car.png`,
          name: '其他车型'
        }
      ]
    }
  },
  methods: {
    getCarModel () {
      getCarModel().then(res => {
        console.log(res)
        if (res.code === 0) { 
          this.count = res.data.length
        }
      })
    },
    getEcmallProducts () {
      getEcmallProducts({channel_no: this.channel_no}).then(res => {
        console.log(res)
        if (res.code === 0) {
          this.productList = res.data.list
        }
      })
    },
    getMyOrders () {
      let token = null
      if (this.channel_no == 'cjjlapp') {
        token = URL.getQueryString('_token') ? URL.getQueryString('_token') : localStorage.cjjlapp_token
        localStorage.setItem('cjjlapp_token', token)
      } else if (this.channel_no == 'agent') {
        token = localStorage.token
      } else {
        token = localStorage.other_token || null
      }
      console.log(token)
      if (token) {
        let data = {
          channel_no: this.channel_no,
          _token: token
        }
        this.$router.push({
          path: `/ecmall/orders`,
          query: data
        })
      } else {
        this.$router.push({
          path: `/ecmall/logon?channel_no=${this.channel_no}`
        })
      }
    },
    toBuy (id) {
      let token = null
      if (this.channel_no == 'cjjlapp') {
        token = URL.getQueryString('_token') ? URL.getQueryString('_token') : localStorage.cjjlapp_token
        localStorage.setItem('cjjlapp_token', token)
      } else if (this.channel_no == 'agent') {
        token = localStorage.token
      } else {
        token = localStorage.other_token || null
      }
      console.log(token)
      if (token) {
        let data = {
          channel_no: this.channel_no,
          agent_id: this.agent_id,
          _token: token,
          id: id
        }
        this.$router.push({
          path: `/ecmall/buy`,
          query: data
        })
      } else {
        this.$router.push({
          path: `/ecmall/logon?channel_no=${this.channel_no}`
        })
      }
    }
  },
  mounted () {
    this.getEcmallProducts()
    this.getCarModel()
  }
}
</script>
<style lang="scss" scoped>
.content {
  font-size: 0;
  padding-bottom: 1rem;
  background: #F2F3FB;
}
.img {
  width: 100%;
  height: auto;
}
.name {
  padding: 0 .3rem;
  height: 1rem;
  align-items: center;
  background: #fff;
  margin-top: .16rem;
  font-size: .28rem;
  display: -webkit-flex;
  display: flex;
  box-shadow: 0px 1px 0px 0px rgba(217, 217, 217, 1);
  div {
    font-weight: 600;
  }
  .item {
    flex: 1;
  }
  .item2 {
    span {
      font-size: .24rem;
      font-weight: 400;
      display: inline-block;
      height: .36rem;
      // width: 1.22rem;
      padding: 0 .14rem;
      text-align: center;
      color: #fff;
      margin-left: .2rem;
      line-height: .36rem;
      border-radius: .18rem;
      &:first-child {
        background:linear-gradient(156.1deg,rgba(249,184,146,1),rgba(251,107,103,1));
      }
      &:last-child {
        background:linear-gradient(156.1deg,rgba(96,190,255,1),rgba(40,146,232,1));
      }
    }
  }
}
.support {
  width: 100%;
  background: #fff;
  padding: 0 .3rem;
  padding-top: .65rem;
  box-sizing: border-box;
  margin-bottom: .16rem;
  .title {
    text-align: center;
    font-size: .32rem;
    font-weight: 600;
    margin-bottom: .88rem;
  }
  .wrap {
    overflow-y: auto;
    width: 100%;
    padding-bottom: .6rem;
    -webkit-overflow-scrolling: touch;
    >div {
      white-space: nowrap;
    }
    .item {
      margin-right: .2rem;
      display: inline-block;
      vertical-align: middle;
      img {
        width: 2.6rem;
        height: 1.8rem;
        border-radius: .2rem;
      }
      .item-name {
        font-size: .28rem;
        text-align: center;
        margin-top: 8px;
      }
    }
  }
}
.btn {
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
  background: #fff;
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: .1rem .3rem;
  box-sizing: border-box;
  font-size: 0;
  button {
    display: inline-block;
    width: 100%;
    font-size: .28rem;
    height: .8rem;
    line-height: .8rem;
    background: #000;
    color: #fff;
    margin-top: .06rem;
  }
}
.my-orders {
  position: fixed;
  bottom: 3rem;
  right: 0;
  img {
    width: 1.5rem;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/productDetail/productDetail_1.vue